import { Directive, ElementRef, inject, input,OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appLazyLoad]',
  standalone: true,
})
export class LazyLoadDirective implements OnInit {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  readonly appLazyLoad = input.required<string>();
  readonly isBackground = input(false);

  ngOnInit(): void {
    const element = this.el.nativeElement;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (this.isBackground()) {
            this.renderer.setStyle(element, 'backgroundImage', `url(${this.appLazyLoad()})`);
          } else {
            this.renderer.setAttribute(element, 'src', this.appLazyLoad());
          }
          observer.unobserve(element);
        }
      });
    });

    observer.observe(element);
  }

}
